export const defaultDurationTimerEvent = 'PT1H';